<template>
    <div>
        <a-row>
            <a-col :span="1"/>
            <a-col :span="8">
                车牌号码：
                <a-input style="width: calc(100% - 100px)" v-model="carNo"/>
            </a-col>
            <a-col :span="4">
                <a-button type="primary" @click="selectCarList">
                    查询
                </a-button>
            </a-col>
            <a-col :span="4">
                <a-button type="primary" @click="addCar">
                    新增
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" bordered :pagination="false" rowKey="id">
            <template slot="operation" slot-scope="text,row">
                <a style="padding-left:5px;" @click="edit(row)">编辑</a>
                <a-divider type="vertical"/>
                <a style="padding-left:5px;color:red" @click="delCar(row)">删除</a>
            </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
        <a-modal v-model="visible"
                 title="车辆信息"
                 width="70%"
                 :centered="true"
                 :maskClosable="false"
                 :bodyStyle="modalBodyStyle"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="add"
                 @cancel="getData">
            <a-row>
                <a-col :span="1"/>
                <a-col :span="2">
                    序号：
                </a-col>
                <a-col :span="4">
                    <a-input-number style="width: 100%" v-model.trim="form.orderNo"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    车牌号：
                </a-col>
                <a-col :span="4">
                    <a-input v-model.trim="form.carNo"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    车辆型号：
                </a-col>
                <a-col :span="4">
                    <a-input v-model.trim="form.type"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="1"/>
                <a-col :span="2">
                    品牌：
                </a-col>
                <a-col :span="4">
                    <a-input v-model.trim="form.brand"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    描述：
                </a-col>
                <a-col :span="4">
                    <a-input v-model.trim="form.descpt"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 30px">
                <a-col :span="3">
                    <strong style="font-size: 20px">司机信息</strong>
                </a-col>
                <a-col :span="19"/>
                <a-col :span="2">
                    <a-button style="float: right" type="primary" @click="addLine">
                        新增
                    </a-button>
                </a-col>
            </a-row>
            <a-divider style="margin: 5px 0"/>
            <a-table :columns="columnsChildren"
                     :data-source="form.carDrivers"
                     :scroll="{y:'300px'}"
                     size="small"
                     :pagination="false"
                     rowKey="id">
                <template
                        v-for="col in ['name', 'phone','duty']"
                        :slot="col"
                        slot-scope="text, record">
                    <div :key="col">
                        <a-input v-model.trim="record[col]"/>
                    </div>
                </template>
                <template slot="orderNo" slot-scope="text, record">
                    <a-input-number v-model.trim="record.orderNo"/>
                </template>
                <template slot="operation" slot-scope="text, record">
                    <a style="color: red" @click="deleteLine(record)">{{record.isDel==='1'?'已删除':'删除'}}</a>
                </template>
            </a-table>
        </a-modal>
        <a-modal v-model="delVisible"
                 title="提示"
                 width="400px"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="delOk"
                 @cancel="cancel">
            <a class="Tips">是否确定删除!</a>
        </a-modal>
    </div>
</template>

<script>
    import {getCarQueryList, carEditDetail, carDelDetail} from './js/ApiBasic';
    import {modalBodyStyle} from "../../config/Config";
    const columns = [
        {
            title: '序号',
            dataIndex: 'orderno',
            key: 'orderno',
            ellipsis: true,
        },
        {
            title: '车牌号',
            dataIndex: 'carno',
            key: 'carno',
            ellipsis: true,
        },
        {
            title: '车辆型号',
            dataIndex: 'type',
            key: 'type',
            ellipsis: true,
        },
        {
            title: '品牌',
            dataIndex: 'brand',
            key: 'brand',
            ellipsis: true,
        },
        {
            title: '描述',
            dataIndex: 'descpt',
            key: 'descpt',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '120px',
            align: 'center',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    const columnsChildren = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
            scopedSlots: {customRender: 'orderNo'},
        },
        {
            title: '人员名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
            scopedSlots: {customRender: 'name'},
        },
        {
            title: '联系电话',
            dataIndex: 'phone',
            key: 'phone',
            ellipsis: true,
            scopedSlots: {customRender: 'phone'},
        },
        {
            title: '职责',
            dataIndex: 'duty',
            key: 'duty',
            ellipsis: true,
            scopedSlots: {customRender: 'duty'},
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '120px',
            align: 'center',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    export default {
        data() {
            return {
                columns,
                columnsChildren,
                modalBodyStyle,
                carNo: '',
                visible: false,
                delVisible: false,
                data: {},
                lines: {},
                form: {
                    orderNo: '',
                    carNo: '',
                    type: '',
                    brand: '',
                    descpt: '',
                    dispatchId: '',
                    carDrivers: [],
                },
            }
        },
        methods: {
            // 查询车辆信息
            selectCarList() {
                this.getData({carNo: this.carNo});
            },
            // 新增车辆
            addCar() {
                this.visible = true;
            },
            // 车辆明细-新增人员
            addLine() {
                this.form.carDrivers.push({});
            },
            // 车辆明细-删除人员
            deleteLine(row) {
                row.isDel = '1';
                let index = this.form.carDrivers.findIndex(item => {
                    return item === row
                });
                this.form.carDrivers.splice(index, 1)
            },
            //新增-点击确定
            add() {
                this.form.orderNo = this.form.orderNo + '';
                this.form.carDrivers.forEach(item=>{
                    item.orderNo = item.orderNo + '';
                });
                carEditDetail(this.form).then(() => {
                    this.visible = false;
                    this.getData()
                }).catch(res => {
                    this.visible = false;
                    console.log(res)
                })
            },
            // 编辑按钮
            edit(row) {
                this.form = JSON.parse(JSON.stringify(row));
                this.form.carNo = row.carno
                this.form.orderNo = row.orderno
                this.visible = true
            },
            //删除按钮
            del(row) {
                carDelDetail({id: row.id}).then(() => {
                    this.getData();
                });
            },
            getData(parameter) {
                if (!parameter) {
                    parameter = {}
                }
                this.resetForm();
                this.visible = false;
                getCarQueryList(parameter).then(res => {
                    this.data = res.data;
                })
            },
            /**
             * 重置form
             */
            resetForm() {
                this.form = {
                    orderNo: '',
                    carNo: '',
                    type: '',
                    brand: '',
                    descpt: '',
                    dispatchId: '',
                    carDrivers: [],
                }
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                getCarQueryList({baseDto: baseDto}).then(res => {
                    this.data = res.data;
                })
            },
            // 删除按钮
            delCar(row){
                this.lines = row;
                this.delVisible = true;
            },
            // 删除提示
            delOk(){
                this.delVisible = false;
                this.del(this.lines);
            },
            cancel(){
                this.delVisible = false;
            }
        },
        created() {
            this.getData();
        }
    }
</script>

<style scoped>
    .Tips{
        font-size: 20px;
        color: #1890ff;
    }
</style>
